import React from "react";
import "./styles.css";
import { Link } from "react-router-dom";

type TestPeriodProps = {
    testPeriod: boolean;
    testPeriodTill?: string;
    handleClose: () => void;
};

export const TestPeriod = ({
                               testPeriod,
                               testPeriodTill,
                               handleClose,
                           }: TestPeriodProps) => {
    if (!testPeriod || !testPeriodTill) return null;

    return (
        <div className="flex flex-col gap-3 text-sm text-slate-900">
            <div className="flex items-start justify-between gap-3">
                <div className="flex flex-col">
          <span className="text-[15px] font-semibold">
            Тестовый период
          </span>
                    <span className="mt-1 text-xs text-[#818c99]">
            Протестируйте сервис перед оформлением подписки.
          </span>
                </div>
                <span className="shrink-0 rounded-full bg-[#fde5f0] px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-[#c06198]">
          АКТИВЕН
        </span>
            </div>

            <p className="text-xs font-medium text-[#0f766e]">
                Доступен до {testPeriodTill}
            </p>

            <div className="mt-1">
                <Link
                    className="inline-flex w-full items-center justify-center rounded-2xl bg-[#c06198] px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-[#a44f81]"
                    to="/payment"
                    onClick={handleClose}
                >
                    Оформить подписку
                </Link>
            </div>
        </div>
    );
};

